/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.AlertsManager {
    angular.module('meevo.plugins.alertsManager', []);
}